import { api } from './client'
import { withCustomerIds } from './params'

export function fetchNasSummary(customerIds = []) {
  return api
    .get('/nas/summary', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}

export function fetchNasHosts(customerIds = []) {
  return api
    .get('/nas/hosts', { params: withCustomerIds({}, customerIds) })
    .then((r) => r.data)
}
